import { LazyImage } from '@components';
import { useStrapiImageFormat } from '@hooks';
import { AddRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import classNames from 'classnames';
import { motion } from 'motion/react';

export default function HeroContent({
  img,
  video,
  isBanner,
  title,
  label,
  description,
  cta,
  isHero,
}) {
  const ctaUrl =
    cta?.href ??
    cta?.externalLink ??
    cta?.file?.data?.attributes?.url;
  return (
    <div className="w-full">
      <motion.div
        initial={
          isHero
            ? { opacity: 0, scale: 1.1 }
            : { opacity: 1, scale: 1 }
        }
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.2, ease: 'easeOut' }}
        viewport={{ once: true }}
        className="hero-media"
      >
        {img && (
          <LazyImage
            img={useStrapiImageFormat({ img })}
            alt="img"
            skeletonCls="absolute left-0 top-0 right-0 bottom-0"
            className={classNames(
              'object-cover w-screen h-[35vh] md:h-[50vh] lg:h-[40vw] -z-10  rounded-t-sm md:rounded-sm',
              isBanner && (title || description) && 'brightness-50',
            )}
          />
        )}

        {video && !img && (
          <video
            src={video}
            loop
            muted
            autoPlay
            className={classNames(
              'object-cover w-full h-[35vh] lg:h-[80vh] -z-10  rounded-t-sm md:rounded-sm',
              isBanner && 'brightness-75	',
            )}
          />
        )}
      </motion.div>

      {isBanner && (
        <div className="absolute top-1/2 -translate-y-1/2 text-neutral text-center left-1/2 -translate-x-1/2 md:space-y-6 w-full md:w-auto">
          <div className="-space-y-1 md:space-y-0">
            {label && (
              <div className="font-voice uppercase tracking-wider text-lg leading non">
                {label}
              </div>
            )}
            <div className="h1">{title}</div>
          </div>
          <div className="body">{description}</div>
          {cta && (
            <Button
              href={ctaUrl}
              target={
                cta?.externalLink ||
                cta?.file?.data?.attributes?.url
                  ? '_blank'
                  : '_self'
              }
              variant="contained"
              size="small"
            >
              {cta?.icon ? (
                cta?.icon
              ) : (
                <AddRounded className="mr-2" />
              )}
              <p className="">{cta?.label}</p>
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
